const SELLERS_TABLE_READY = "sellers-table-ready"
const SEARCH_TEXT_STATE = "sellers-table-search-text-state"
const ROWS_PER_PAGE_STATE = "sellers-table-rows-per-page-state"
const PAGINATION_STATE = "sellers-table-pagination-state"

const SELLER_ID_FOR_ACTION = "sellers-table-seller-id-for-action"


const initialState = {
    isSellersTableReady: true,
    sellers: {},

    
    sellerSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case SELLERS_TABLE_READY:
            return Object.assign({}, state, { isSellersTableReady: action.payload })
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case SELLER_ID_FOR_ACTION:
            return Object.assign({}, state, {sellerSelectedId:action.payload})

        default:
        return state
    
    }

}

export function sellerTableReady(data) {
    return {
        type: SELLERS_TABLE_READY,
        payload: data
    }
}

export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function sellerIdForAction(sellerId){
    return{
        type:SELLER_ID_FOR_ACTION,
        payload:sellerId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Sellers/redux/sellers.js